import Superagent from 'superagent'
import Storage from './storage.service'

const { HOST_API } = _CONSTANTS_

export default {
    userLogin,
    createUser,
    getUsers,
    getUsersFind,
    getUsersReport,
    updateUser,
    updateUserAdviser,
    zipcodes
}

function userLogin(data) {
    return new Promise((resolve, reject) => {
        Superagent
           .post(`${HOST_API}/login`)
           .send(data)
           .end((err, res) => {

                if(!err && res.body) {
                    Storage.setItem('user', res.body.data.user)
                    Storage.setItem('access', res.body.data.access)
                }

               resolve(res.body)
           })
    })
}

function createUser(data) {
    return new Promise((resolve, reject) => {
        Superagent
           .post(`${HOST_API}/users`)
           .set('access', Storage.getItem('access'))
           .send(data)
           .end((err, res) => {
               resolve(res.body)
           })
    })
}

function getUsers(query) {
    return new Promise((resolve, reject) => {
        Superagent
           .get(`${HOST_API}/users`)
           .set('access', Storage.getItem('access'))
           .query(query)
           .end((err, res) => {
               resolve(res.body)
           })
    })
}

function getUsersReport(query) {
    return new Promise((resolve, reject) => {
        Superagent
           .get(`${HOST_API}/users/report`)
           .set('access', Storage.getItem('access'))
           .query(query)
           .responseType('blob')
           .end((err, res) => {
               resolve(res.body)
           })
    })
}

function getUsersFind(query) {
    return new Promise((resolve, reject) => {
        Superagent
           .get(`${HOST_API}/users/find`)
           .set('access', Storage.getItem('access'))
           .query(query)
           .end((err, res) => {
               resolve(res.body)
           })
    })
}

function updateUser(userId, data) {
    return new Promise((resolve, reject) => {
        Superagent
           .put(`${HOST_API}/users`)
           .set('access', Storage.getItem('access'))
           .query({userId})
           .send(data)
           .end((err, res) => {
               resolve(res.body)
           })
    })
}

function updateUserAdviser(userId, data) {
    return new Promise((resolve, reject) => {
        Superagent
           .put(`${HOST_API}/users/${userId}/adviser`)
           .set('access', Storage.getItem('access'))
           .send(data)
           .end((err, res) => {
               resolve(res.body)
           })
    })
}

function zipcodes(data) {
    return new Promise((resolve, reject) => {
        Superagent
           .put(`${HOST_API}/users/zipcodes`)
           .set('access', Storage.getItem('access'))
           .send(data)
           .end((err, res) => {
               resolve(res.body)
           })
    })
}